import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

/**
 * @param userId сравниваем обычно с данными из урла, поэтому строка
 */
export const useIsCurrentUser = (userId: string) => {
  const { currentUserId } = useShallowEqualSelector(
    ({ userReducer: { userId: currentUserId } }) => ({
      currentUserId,
    })
  )
  return Number(userId) === currentUserId
}
